export enum EmotionEpisodeRecordingStatusTypes {
    none = 'none',
    awaiting_playback = 'awaiting_playback',
    playback_initiated = 'playback_initiated',
    recording = 'recording',
    completed = 'completed',
}
